import { PureComponent } from 'react';
import classNames from 'classnames/bind';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';

import { getFormattedQuery } from '../../../../helpers/helpers';
import { getTrendingBarAssetQuery } from '../../../../helpers/watchlistHelperFunctions';
import withComponentName from '../../../../decorators/withComponentName';

import { DIRECTORIES_PATH } from '../../../../data/directory/constants';

import Preloader from '../../../Preloader';
import Charts from '../../Charts';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

export class ChartsAndData extends PureComponent {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      loading: true,
      currentPath: '',
    };
    this.mainTicker = null;
  }

  componentDidMount() {
    const { slug, isWatchlist } = this.props;
    const assetClass = slug.asset_class;
    const currentPath = isWatchlist
      ? '/watchlists/charts'
      : `${DIRECTORIES_PATH}/${assetClass.slug}/${slug.slug}/charts`;
    this.setState({
      currentPath,
    });
    window.addEventListener('resize', this.onResize, { passive: true });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    this.forceUpdate();
  }

  onChartsInit() {
    this.setState({ loading: false });
  }

  render() {
    const { loading, currentPath } = this.state;
    const {
      slug,
      assetType,
      onChartExpandClick,
      isWatchlist,
    } = this.props;

    const { mainTicker } = slug || {};

    return (
      <section className={cx('charts-and-data')}>
        <Preloader loading={loading} static centered />
        <div className={cx({ invisible: loading })}>
          <Charts
            hasBigScreenDesign
            isWatchlist={isWatchlist}
            currentPath={currentPath}
            assetType={assetType}
            selector={[mainTicker]}
            onDataInit={this.onChartsInit}
            query={(
              getFormattedQuery(
                getTrendingBarAssetQuery(slug, 'Topic'),
              )
            )}
            slug={slug}
            onChartExpandClick={onChartExpandClick}
            adaptiveChatbotOpenClose
          />
        </div>
      </section>
    );
  }
}

const mapStateToProps = ({ chatbot, common }) => ({
  isChatbotOpened: chatbot.isChatbotOpened,
  width: common.width,
});

export default withComponentName(connect(mapStateToProps, null)(ChartsAndData));
